import { Text } from "@wearewqa/wqa-design-system";
import React from "react";
import styled, { css } from "styled-components";
import { Container } from "../Container";

// interface FooterProps {}

const StyledFooter = styled.header(
  () => css`
    padding: 20px 0;
  `
);

export const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <Container>
        <Text size="textXs" align="center" element="p">
          Copyright WQA
        </Text>
      </Container>
    </StyledFooter>
  );
};
